import './share-screen.scss'

/**
 *  Component Definition
 *
 * @export
 * @class shareScreen
 * @implements {ng.IComponentOptions}
 */
export class ShareScreen implements ng.IComponentOptions {

  /**
   * Controller used with Component
   *
   * @type {Function}
   */
  public controller: ng.IControllerConstructor = ShareScreenController

  /**
   * Template used with Component
   *
   * @type {string}
   */
  public template: string = require('./share-screen.html').toString()

  /**
     * Object containing pairs Directive Bindings for Component
     *
     * @type {Object}
     */
  public bindings: { [binding: string]: string; } = {

  }
}

/**
 * shareScreen - Controller
 *
 * @export
 * @class shareScreenController
 */
export class ShareScreenController {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', 'AngularServices', 'AppServices', '$rootScope']
  public imageurl

  /**
   * @param {*} $log Angular Log Service
   * @param {*} AngularServices Angular Services Convenience Service
   * @param {*} AppServices App Services Convenience Service
   */
  constructor(public $log: any, public AngularServices: any, public AppServices: any, public $rootScope: any) {
    this.$log = $log.getInstance('shareScreen', false);
    this.$log.debug('constructor')
  }

  public onEnterStart() {
    this.$log.debug('onEnterStart');
  }

  public onEnterComplete() {
    this.$log.debug('onEnterComplete');
  }

  public onExitStart() {
    this.$log.debug("onExitStart")
  }

  public onExitComplete() {
    this.$log.debug("onExitComplete")
  }

  /**
   * life cycle hooks (road to ng2)
   * Called on each controller after all the controllers on an element have been constructed and had their bindings initialized (and before the pre & post linking functions for the directives on this element).
   */
  public $onInit(): void {
    this.$log.debug('onInit')

    let url = this.AppServices.ScreenManager.getURLParam( 'imageurl' );
    if (url !== ''){
      this.imageurl = this.AppServices.DataManager.config.settings.sharedImageURL + url;
    }
  }

  /**
   * Called whenever one-way bindings are updated.
   * The changesObj is a hash whose keys are the names of the bound properties that have changed, and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
   * Use this hook to trigger updates within a component such as cloning the bound value to prevent accidental mutation of the outer value.
   */
  public $onChanges(changesObj): void {
    this.$log.debug('onChanges')
  }

  /**
   * Called on a controller when its containing scope is destroyed.
   * Use this hook for releasing external resources, watches and event handlers.
   */
  public $onDestroy(): void {
    this.$log.debug('onDestroy')
  }

  /**
   * Called after this controller's element and its children have been linked.
   * Similar to the post-link function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
   * Note that child elements that contain templateUrl directives will not have been compiled and linked since they are waiting for their template to load asynchronously and their own compilation and linking has been suspended until that occurs.
   * This hook can be considered analogous to the ngAfterViewInit and ngAfterContentInit hooks in Angular 2.
   * Since the compilation process is rather different in Angular 1 there is no direct mapping and care should be taken when upgrading.
   */
  public $postLink(): void {
    this.$log.debug('postLink')
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/share-screen/share-screen.ts
 **/